export default __webpack_public_path__ + "static/media/custom-form-mini-icon.4b67a1e8.svg";